import PripomienkaVyhodnotPage from './PripomienkaVyhodnotPage';

export default PripomienkaVyhodnotPage;
